module.exports = __webpack_public_path__ + "static/media/blik.866bece6.svg";